module.exports = __webpack_public_path__ + "img/TaktvsSKY.a1aa8194.png";